/**
 * Component: PaymentInfoCard
 * Payment instructions + bank QR as registrants will see them. Visible to admins
 * in any event status (the public page only exists once the event is open).
 */

import { CreditCard } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { getEventPaymentQrUrl } from '@/Services/events.service';
import type { Event } from '@/types/event.types';
import { PaymentQrCard } from '../public/components/PaymentQrCard';

export function PaymentInfoCard({ event }: { event: Event }) {
  const qrUrl = getEventPaymentQrUrl(event.payment_qr_filename);
  if (!qrUrl && !event.payment_instructions) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <CreditCard className="size-5" />
          Pago de inscripción
        </CardTitle>
      </CardHeader>
      <CardContent className="grid gap-4 md:grid-cols-2">
        {event.payment_instructions && (
          <p className="whitespace-pre-wrap text-sm text-muted-foreground">{event.payment_instructions}</p>
        )}
        {qrUrl && <PaymentQrCard url={qrUrl} fileLabel={event.code} />}
      </CardContent>
    </Card>
  );
}
